import { useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { FormResponseOwnerTypeEnum , useOrgFormResponseQuery } from '@alice-financial/alice-sdk'
import { useOrgId } from '../useOrgId'
import {
  FormResponseConfig,
  useCreateFormResponse,
  UseCreateFormResponseMutationOptions,
} from './useCreateFormResponse'

type OrgFormResponseConfig = Pick<FormResponseConfig, 'formName' | 'formVersion'>

export const useCreateOrgFormResponse = (
  { formName, formVersion }: OrgFormResponseConfig,
  mutationOptions?: UseCreateFormResponseMutationOptions
) => {
  const orgId = useOrgId()
  const mutationOptionsWithInvalidation = useMutationOptionsWithInvalidation(mutationOptions, [
    useOrgFormResponseQuery.getKey({ id: orgId, formName, formVersion }),
  ])
  return useCreateFormResponse(
    { formName, formVersion, ownerId: orgId, ownerType: FormResponseOwnerTypeEnum.Org },
    mutationOptionsWithInvalidation
  )
}
